import { C } from 'jssip'
import { isCSV2 } from 'modules/Helpers'

export const APP_ENTITIES = {
  DEPARTMENT: 'deptname',
  WELCOME_MENU: 'menuname',
  RING_GROUP: 'rgname',
  USER: 'callinguser',
  INCOMING: 'incoming',
  OUTGOING: 'outgoing',
  CALL_QUEUE: 'cqname',
}

const decline = 603

const sessions = {
  entities: {
    list: [
      APP_ENTITIES.DEPARTMENT,
      APP_ENTITIES.WELCOME_MENU,
      APP_ENTITIES.RING_GROUP,
      APP_ENTITIES.CALL_QUEUE,
      APP_ENTITIES.USER,
    ],
    names: {
      department: APP_ENTITIES.DEPARTMENT,
      welcomeMenu: APP_ENTITIES.WELCOME_MENU,
      ringGroup: APP_ENTITIES.RING_GROUP,
      callQueue: APP_ENTITIES.CALL_QUEUE,
      user: APP_ENTITIES.USER,
    },
  },
  direction: {
    incoming: APP_ENTITIES.INCOMING,
    outgoing: APP_ENTITIES.OUTGOING,
  },
  options: {
    decline: {
      status_code: decline,
      reason_phrase: C.REASON_PHRASE[decline], // this is mapped by default in JsSIP
    },
  },
  hidden: {
    unavailable: 'Unavailable',
    restricted: 'Restricted',
    anonymous: 'anonymous',
  },
}
export const REASON = {
  header: 'Reason',
  headerKey: 'SIP',
  key: 'cause',
  value: '200',
  parked: {
    key: 'text',
    value: 'call parked',
    slotKey: 'slot',
  },
}
export const ENTITIES_MAP = {
  [APP_ENTITIES.DEPARTMENT]: 'department',
  [APP_ENTITIES.RING_GROUP]: 'ringGroup',
  [APP_ENTITIES.USER]: 'teamMember',
  [APP_ENTITIES.WELCOME_MENU]: 'welcomeMenu',
  [APP_ENTITIES.CALL_QUEUE]: 'callQueues',
}
export const SETUP_TYPE = {
  PASSIVE: 'a=setup:passive',
  ACTPASS: 'a=setup:actpass',
}
export const MESSAGE_TYPE = { OFFER: 'offer', ANSWER: 'answer' }
export const ORIGIN = { REMOTE: 'remote', LOCAL: 'local' }
export const HEADER_ENTITIES = sessions.entities.list
export const CUSTOM_HEADER = 'P-Idt-Webrtc'
export const SHOW_MISSED_HEADER = 'displayMissedCall'
export const REFER_CODES = {
  PARK: {
    ACTION: 'park',
    CODE: '*4',
  },
  TRANSFER_TO_VOICEMAIL: {
    ACTION: 'voicemail',
  },
}
Object.defineProperty(REFER_CODES.TRANSFER_TO_VOICEMAIL, 'CODE', {
  get() {
    return isCSV2() ? '*3' : '#3'
  },
})

export default sessions
